/**
 *  Created by piotr@revisual.io on 04/08/2025
 */

import React, { useMemo } from "react";

/**
 * OnboardingProgress component displays the progress bar for the onboarding process.
 * @param {number} progress
 * @returns {JSX.Element}
 * @constructor
 */
export const OnboardingProgress = ({ progress = 0 }) => {
  const progressValue = useMemo(() => ({ width: `${progress}%` }), [progress]);

  return (
    <div className="onboarding-progress">
      <div
        className="progress-bar"
        role="progressbar"
        style={progressValue}
        aria-valuenow={progress}
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  );
};

export default OnboardingProgress;
